<template>
  <v-dialog v-model="dialog" max-width="1400px">
    <v-card>
      <v-card-title>
        {{ $t('tslOrders.orderHistory') }}
        <v-spacer />
        <v-btn icon @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="historyData"
          :loading="loading"
          hide-default-footer
          :items-per-page="-1"
        >
          <template v-slot:[`item.userName`]="{ item }">
            {{ item.userName }} {{ item.userSurname }}
          </template>
          <template v-slot:[`item.dateTime`]="{ item }">
            {{ formatDateTime(item.dateTime) }}
          </template>
          <template v-slot:[`item.fieldName`]="{ item }">
            {{ translateFieldName(item.fieldName) }}
          </template>
          <template v-slot:[`item.oldValue`]="{ item }">
            <div v-if="containsHtml(item.oldValue)" v-html="formatValue(item.oldValue)" class="html-content"></div>
            <pre v-else-if="isMultilineField(item.fieldName)" class="multiline-content">{{ formatValue(item.oldValue) }}</pre>
            <span v-else>{{ formatValue(item.oldValue) }}</span>
          </template>
          <template v-slot:[`item.newValue`]="{ item }">
            <div v-if="containsHtml(item.newValue)" v-html="formatValue(item.newValue)" class="html-content"></div>
            <pre v-else-if="isMultilineField(item.fieldName)" class="multiline-content">{{ formatValue(item.newValue) }}</pre>
            <span v-else>{{ formatValue(item.newValue) }}</span>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'OrderHistoryDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    historyData: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dialog: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    headers () {
      return [
        { text: this.$t('tslOrders.history.user'), value: 'userName' },
        { text: this.$t('tslOrders.history.dateTime'), value: 'dateTime' },
        { text: this.$t('tslOrders.history.field'), value: 'fieldName' },
        { text: this.$t('tslOrders.history.oldValue'), value: 'oldValue' },
        { text: this.$t('tslOrders.history.newValue'), value: 'newValue' }
      ]
    }
  },
  methods: {
    formatDateTime (dateString) {
      if (!dateString) return '-'
      const date = new Date(dateString)
      return date.toLocaleString()
    },
    formatValue (value) {
      if (!value || value === 'null' || value === 'undefined') return '-'
      return value
    },
    containsHtml (value) {
      // Sprawdź czy wartość zawiera tagi HTML
      if (!value || typeof value !== 'string') return false
      // Prosty regex do wykrycia tagów HTML
      return /<[^>]+>/gi.test(value)
    },
    isMultilineField (fieldName) {
      // Pola, które zawierają wieloliniowy tekst (nie HTML)
      const multilineFields = ['Places']
      return multilineFields.includes(fieldName)
    },
    translateFieldName (fieldName) {
      const fieldTranslations = {
        ClientContractorId: this.$t('tslOrders.fields.selectClient'),
        CarrierContractorId: this.$t('tslOrders.fields.selectCarrier'),
        Places: this.$t('tslOrders.tabs.route'),
        Notes: this.$t('tslOrders.fields.notes'),
        CargoDescription: this.$t('tslOrders.fields.cargoDescription'),
        FtlLtl: this.$t('tslOrders.fields.ftlLtl'),
        CustomsInfo: this.$t('tslOrders.fields.customsInfo'),
        CabotageInfo: this.$t('tslOrders.fields.cabotageInfo'),
        AdrInfo: this.$t('tslOrders.fields.adrInfo'),
        ClientPhone: this.$t('tslOrders.fields.clientPhone'),
        ClientEmail: this.$t('tslOrders.fields.clientEmail'),
        ClientPrice: this.$t('tslOrders.fields.clientPrice'),
        ClientCurrency: this.$t('tslOrders.fields.clientCurrency'),
        ClientRefNumber: this.$t('tslOrders.fields.clientRefNumber'),
        CarrierFullName: this.$t('tslOrders.fields.carrierFullName'),
        CarrierPhone: this.$t('tslOrders.fields.carrierPhone'),
        CarrierEmail: this.$t('tslOrders.fields.carrierEmail'),
        CarrierPrice: this.$t('tslOrders.fields.carrierPrice'),
        CarrierCurrency: this.$t('tslOrders.fields.carrierCurrency'),
        CarrierVehicleType: this.$t('tslOrders.fields.carrierVehicleType'),
        CarrierNotes: this.$t('tslOrders.fields.carrierNotes'),
        CarrierRegistrationNumber: this.$t('tslOrders.fields.carrierRegistrationNumber'),
        CarrierPaymentType: this.$t('tslOrders.fields.carrierPaymentType'),
        CarrierPaymentDays: this.$t('tslOrders.fields.carrierPaymentDays'),
        Commission: this.$t('tslOrders.commission'),
        Archived: this.$t('tslOrders.fields.archived')
      }
      return fieldTranslations[fieldName] || fieldName
    }
  }
}
</script>

<style scoped>
.html-content {
  max-width: 600px;
  overflow: auto;
  padding: 8px;
  background-color: #f9f9f9;
  border-radius: 4px;
}

.html-content ::v-deep p {
  margin: 0;
  padding: 2px 0;
}

.html-content ::v-deep ul,
.html-content ::v-deep ol {
  margin: 0;
  padding-left: 20px;
}

.html-content ::v-deep strong {
  font-weight: bold;
}

.html-content ::v-deep u {
  text-decoration: underline;
}

.multiline-content {
  max-width: 600px;
  overflow: auto;
  white-space: pre-line;
  font-family: inherit;
  font-size: inherit;
  margin: 0;
  padding: 8px;
  background-color: #f5f5f5;
  border-radius: 4px;
  line-height: 1.5;
}
</style>
